import { NgModule, Component } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login";
import { AuthGuard } from "./_helpers";
import { DashboardComponent } from "./dashboard";
import { ThingsComponent } from "./dashboard/things";
import { AccessComponent } from "./dashboard/access/access.component";
import { SettingsComponent } from "./dashboard/settings/settings.component";
import { ThingSettingsComponent } from "./dashboard/things/thing-settings/thing-settings.component";
import { ThingSettingsEditComponent } from "./dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component";

const routes: Routes = [
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "things",
        component: ThingsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "thingDetails/:id/:accessoryId",
        component: ThingSettingsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "access",
        component: AccessComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "settings",
        component: SettingsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "edit/:id",
        component: ThingSettingsEditComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "things/:label",
        component: ThingsComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "**",
    component: LoginComponent
  }
];

export const routing = RouterModule.forRoot(routes, {
  useHash: true
});
